export default __webpack_public_path__ + "static/media/No.6-5.3bd45b72.jpg";